import React, {  useState } from "react";
import {  useNavigate } from "react-router-dom";

import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";

function Contractsdashboard({ id, activecontract }) {
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");

  let navigate = useNavigate();

  const handleView = (id) => {
    navigate("/contract/view", { state: id });
  };

  return (
    <>
      <div className="">
        <div className=" px-0 pb-2">
          <div className="table-responsive">
            <table className="table table-striped align-items-center mb-0">
              <thead>
                <tr>
                  <th className="text-uppercase  text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                    {t("CONTRACT NUMBER")}
                  </th>
                  <th className="text-uppercase text-left text-secondary text-xxs font-weight-bolder opacity-7">
                    {t("CUSTOMER NAME")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    {t("AMOUNT FINANCED")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    {t("UNBILLED AMOUNT")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    {t("AMOUNT DUE")}
                  </th>
                  <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    {t("TERM")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {activecontract.map((key) => (
                  <tr>
                    <td className="text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("CONTRACT NUMBER")}{" "}
                        </div>
                        <div>
                          <span
                            onClick={() => permissionss && permissionsArray.includes('view_contract')===true ?  handleView(key.id) : ""}
                            className="hyperlink"
                          >
                            {key.contract_number}
                          </span>
                        </div>
                      </>
                    </td>
                    <td className="text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("CUSTOMER NAME")}{" "}
                        </div>
                        <div>{key.party}</div>
                      </>
                    </td>
                    <td className="align-middle text-left ">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("AMOUNT FINANCED")}
                        </div>
                        <div>{Helper.Amount(key.financed_amount)}</div>
                      </>
                    </td>
                    <td className="align-middle text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("UNBILLED AMOUNT")}{" "}
                        </div>
                        <div>{Helper.Amount(key.unbilled)}</div>
                      </>
                    </td>
                    <td className="align-middle text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("AMOUNT DUE")} </div>
                        <div>{Helper.Amount(key.total_due)}</div>
                      </>
                    </td>
                    <td className="align-middle text-left">
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("TERM")} </div>
                        <div>
                          {key.terms}
                        </div>
                      </>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contractsdashboard;
